import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { __decorate } from "tslib";
import { Component, inject } from 'intact-vue-next';
import template from './option.vdt';
import { bind, toggleArray } from '../utils';
import { SELECT } from './constants';
import { useConfigContext } from '../config';
var typeDefs = {
  value: {
    required: true
  },
  label: String,
  disabled: Boolean
};
export var Option = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Option, _Component);
  function Option() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.select = inject(SELECT);
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Option.prototype;
  _proto.onSelect = function onSelect() {
    var select = this.select;
    var multiple = select.get('multiple');
    var value = this.get('value');
    if (!multiple) {
      select.set('value', this.get('value'));
    } else {
      var values = select.get('value');
      values = toggleArray(values, value);
      select.set('value', values);
    }
  };
  _proto.isActive = function isActive() {
    var _this$select$get = this.select.get(),
      currentValue = _this$select$get.value,
      multiple = _this$select$get.multiple;
    var value = this.get('value');
    if (multiple) {
      if (Array.isArray(currentValue)) {
        return _includesInstanceProperty(currentValue).call(currentValue, value);
      }
      return false;
    }
    return currentValue === value;
  };
  return Option;
}(Component);
Option.template = template;
Option.typeDefs = typeDefs;
__decorate([bind], Option.prototype, "onSelect", null);